<script lang="ts" setup>
defineProps<{
  id: number
  title?: string
  content: string
  cover?: string
  tags?: string[]
  images?: string[]
  likes: number
  views: number
  comments?: number
  userId: number
  username: string
  userAvatar: string
  badges: number[]
  userAuth?: User.Auth
  createdAt: number
}>()
</script>

<template>
  <div class="m-feed-card-forward">
    <div class="m-feed-card-forward__header">
      <m-user-info
        :id="userId"
        :name="username"
        :avatar="userAvatar"
        :badges="badges"
        :auth="userAuth"
        size="xs"
      >
        <div>{{ pipe.date(createdAt) }}</div>
      </m-user-info>
    </div>
    <m-link :resource-id="id" :resource-type="3" :title="title">
      <div class="m-feed-card-forward__title">
        <h3 class="m-feed-card-forward__h3">{{ title }}</h3>
      </div>
      <div class="m-feed-card-forward__content" v-html="xss(content)"></div>
      <div v-if="images?.length" class="m-feed-card-forward__preview">
        <m-image-preview>
          <m-gallery :list="images" />
        </m-image-preview>
      </div>
    </m-link>
    <div class="m-feed-card-forward__footer">
      <div v-if="tags?.length" class="m-feed-card-forward__tags">
        <m-topics :topics="tags" />
      </div>
      <div class="m-feed-card-forward__data">
        <div class="m-feed-card-forward__data-item">
          <span>{{ pipe.num(views) }}阅读</span>
        </div>
        <div class="m-feed-card-forward__data-item">
          <span>{{ pipe.num(comments) }}评论</span>
        </div>
        <div class="m-feed-card-forward__data-item">
          <span>{{ pipe.num(likes) }}赞</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-feed-card-forward {
  &__header {
    margin-bottom: 16px;
  }
  &__title {
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    padding-right: 100px;
  }
  &__h3 {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    padding: 0;
  }
  &__content {
    line-height: 18px;
    margin-top: 8px;
    color: var(--color-gray-600);
  }
  &__preview {
    margin-top: 5px;
  }
  &__data {
    margin-top: 5px;
    display: flex;
    align-items: center;
    &-item {
      margin-right: 10px;
      display: flex;
      align-items: center;
      > span {
        padding-right: 8px;
        font-size: 12px;
        color: var(--color-gray-500);
      }
    }
  }
}
</style>
